import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=abee6f94&scoped=true"
import script from "./PublicFooter.vue?vue&type=script&lang=js"
export * from "./PublicFooter.vue?vue&type=script&lang=js"
import style0 from "./PublicFooter.vue?vue&type=style&index=0&id=abee6f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abee6f94",
  null
  
)

export default component.exports